import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=2db96d6b&"
import script from "./FileEditor.vue?vue&type=script&lang=ts&"
export * from "./FileEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FileEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports